import React from 'react'
import MemberLanyard from '../components/MemberLanyard.jsx'
import TeamIntro from '../components/TeamIntro.jsx'

const team = [
  {
    name: "Jaymeet (Jimmy) Patel",
    role: "CEO & CSO",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/jaymeet.glb",
    about:
      "Jimmy leads DevBrows with vision and strategy. As both CEO and CSO, he balances business growth with security foresight, ensuring the company not only scales, but scales safely. His leadership anchors the team through every pivot and breakthrough."
  },
  {
    name: "Kirtan Patel",
    role: "CTO",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/kirtan.glb",
    about:
      "Kirtan is the tech backbone of DevBrows. A fearless architect of scalable systems, he drives development with clarity and innovation. Whether designing infrastructure or debugging at 2 AM, he’s all in for tech done right."
  },
  {
    name: "Manan Patel",
    role: "CMO and Marketing Head",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/manan.glb",
    about:
      "Manan brings the brand to life. As CMO and Marketing Head, he connects DevBrows with its audience using campaigns that resonate. His strategies make tech feel human and relatable, bringing in results and recognition."
  },
  {
    name: "Shail Patel",
    role: "CFO",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/shail.glb",
    about:
      "Shail keeps the finances focused and future-ready. As CFO, he manages budgets, forecasts growth, and ensures that every dollar spent returns tenfold in impact. He’s the calm, calculated force in our momentum."
  },
  {
    name: "Deven Patel",
    role: "Developer and AI Strategist",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/deven.glb",
    about:
      "Deven codes with purpose and thinks with AI. As the team’s AI Strategist, he builds intelligent systems that power user experiences behind the scenes. Always exploring the edge of machine learning and development."
  },
  {
    name: "Dev Shah",
    role: "Developer and QA",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/dev.glb",
    about:
      "Dev ensures every line of code is battle-tested. As both a developer and QA expert, he builds features and breaks them before users can. Precision, patience, and polish define his work."
  },
  {
    name: "Kalash Shah",
    role: "SEO Strategist",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/kalash.glb",
    about:
      "Kalash optimizes every pixel for discoverability. As SEO Strategist, he ensures that DevBrows not only works well—but ranks well. Keywords, algorithms, and analytics are his everyday playground."
  },
  {
    name: "Neel Patel",
    role: "Prototyping and Market Analyst",
    model: "https://devbrows-glb-assets.s3.us-east-1.amazonaws.com/neel.glb",
    about:
      "Neel turns ideas into tangible mockups. As our prototyping and market analyst, he aligns design with demand, validating features before they ship. Insightful, iterative, and always one user test ahead."
  }
];

export default function TeamPage() {
  return (
    <div>
      <TeamIntro />
      {team.map((person, idx) => (
        <MemberLanyard key={idx} person={person} index={idx} />
      ))}
    </div>
  )
}
